<template>
  <v-container grid-list-md>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <base-card
          title="Download"
          icon="cloud_download"
        >
          <v-tabs slider-color="primary">
            <v-tab>
              Blood Data
            </v-tab>
            <v-tab>
              Tissue Data
            </v-tab>
            <v-tab-item v-for="dataType in dataTypes" :key="dataType">
              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="tableData[dataType]"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td>{{props.item.cancer}}</td>
                    <td>{{props.item.tissue}}</td>
                    <td>
                      <a
                        v-if="props.item.exprLevelRNATypes"
                        v-for="rnaType in props.item.exprLevelRNATypes.split(',')"
                        :key="rnaType"
                        class="download-link"
                        :href="getDownloadUrl(
                          dataType,
                          props.item.baseFileName,
                          rnaType,
                          'exprLevel'
                        )"
                        download
                      >
                        <v-btn small outline color="primary">
                          {{rnaType}}
                        </v-btn>
                      </a>
                    </td>
                    <td>
                      <a
                        v-if="props.item.diffExprRNATypes"
                        v-for="rnaType in props.item.diffExprRNATypes.split(',')"
                        :key="rnaType"
                        class="download-link"
                        :href="getDownloadUrl(
                          dataType,
                          props.item.baseFileName,
                          rnaType,
                          'diffExpr'
                        )"
                        download
                      >
                        <v-btn small outline color="primary">
                          {{rnaType}}
                        </v-btn>
                      </a>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </base-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import tableData from '@/assets/data/DownloadTable';

export default {
  data() {
    return {
      headers: [
        {
          text: 'Cancer',
          value: 'cancer',
        },
        {
          text: 'Tissue',
          value: 'tissue',
        },
        {
          text: 'Expression Level',
          value: 'exprLevelRNATypes',
          align: 'center',
        },
        {
          text: 'Differential Expression',
          value: 'diffExprRNATypes',
          align: 'center',
        },
      ],
      tableData,
      dataTypes: ['blood', 'tissue'],
    };
  },
  methods: {
    getDownloadUrl(bloodOrTissue, baseFileName, rnaType, dataType) {
      const subFolder1 = bloodOrTissue === 'blood' ? 'BloodData' : 'TissueData';
      const subFolder2 = dataType === 'diffExpr' ? 'DifferentialExpression' : 'ExpressionLevel';
      return `../download/${subFolder1}/${subFolder2}/${baseFileName}.${rnaType}.${dataType}.zip`;
    },
  },
};
</script>

<style lang="scss" scoped>
.download-link {
  .v-btn {
    text-transform: none;
  }

  &:hover {
    text-decoration: none;
  }
}
</style>
